module.exports = __webpack_public_path__ + "static/media/ceremonie.e27594e0.jpg";